(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5342],{

/***/ 5784:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts/[categorySlug]/[postSlug]",
      function () {
        return __webpack_require__(66978);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 24100:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/defaultpic.119a8e64.webp","height":269,"width":264,"blurDataURL":"data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoIAAgAAkA4JaQAA3AA/vgQAAA=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 64465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69587);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12820);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_shared_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _schemaorg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91257);








var PageHeader = function(props) {
    var _breadcrumb = props.breadcrumb, breadcrumb = _breadcrumb === void 0 ? [] : _breadcrumb, dbName = props.dbName;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var schema = (0,_schemaorg__WEBPACK_IMPORTED_MODULE_6__/* .schemaPageHeader */ .ed)(dbName, router.asPath, breadcrumb);
    if (breadcrumb.length > 0) {
        var lastIndex = breadcrumb.length - 1;
        breadcrumb = breadcrumb.map(function(item, index) {
            var link;
            if (lastIndex === index) {
                link = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_5___default()), {
                            id: schema.name,
                            type: "application/ld+json",
                            dangerouslySetInnerHTML: {
                                __html: JSON.stringify(schema)
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-item"]), " ").concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-item-active"])),
                            "aria-current": "page",
                            children: item.title
                        })
                    ]
                }, index);
            } else {
                link = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                    className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-item"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: item.url,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: item.title
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .ArrowRoundedRight6x9Svg */ .EO, {
                            className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-arrow"])
                        })
                    ]
                }, index);
            }
            return link;
        });
        breadcrumb = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["page-header__breadcrumb"]),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                "aria-label": "breadcrumb",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                    className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default().breadcrumb),
                    children: breadcrumb
                })
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["page-header"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["page-header__container"]), " container"),
            children: breadcrumb
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageHeader);


/***/ }),

/***/ 76210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* reexport safe */ _context_GlobalContext__WEBPACK_IMPORTED_MODULE_0__.b; }
/* harmony export */ });
/* harmony import */ var _context_GlobalContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68912);



/***/ }),

/***/ 66978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _postSlug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./helper.js
var helper = __webpack_require__(63385);
// EXTERNAL MODULE: ./components/posts/posts.module.scss
var posts_module = __webpack_require__(30406);
var posts_module_default = /*#__PURE__*/__webpack_require__.n(posts_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./images/defaultpic.webp
var defaultpic = __webpack_require__(24100);
// EXTERNAL MODULE: ./services/utils.js
var utils = __webpack_require__(75681);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next-share/dist/next-share.es.js
var next_share_es = __webpack_require__(21818);
// EXTERNAL MODULE: ./hooks/useGlobal.ts
var useGlobal = __webpack_require__(76210);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(81043);
;// CONCATENATED MODULE: ./components/shared/SMSharedButton.tsx






var SMSharedButton = function(param) {
    var url = param.url;
    var ref = (0,useGlobal/* useGlobal */.O)(), dbName = ref.dbName, domain = ref.domain;
    var cacheVersion = (0,es/* useSelector */.v9)(function(state) {
        return state.general.cashVersion;
    });
    var logoPath = (0,helper/* domainUrl */.HJ)("".concat(dbName, "/storage/").concat(domain, "/configuration/logo/logo.webp?v=").concat(cacheVersion));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_share_es/* FacebookShareButton */.Dk, {
                url: url,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_share_es/* FacebookIcon */.Vq, {
                    size: 32,
                    round: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_share_es/* TwitterShareButton */.B, {
                url: url,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_share_es/* TwitterIcon */.Zm, {
                    size: 32,
                    round: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_share_es/* PinterestShareButton */.MC, {
                url: url,
                media: logoPath,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_share_es/* PinterestIcon */.cH, {
                    size: 32,
                    round: true
                })
            })
        ]
    });
};
/* harmony default export */ var shared_SMSharedButton = (SMSharedButton);

// EXTERNAL MODULE: ./svg/index.js
var svg = __webpack_require__(69587);
;// CONCATENATED MODULE: ./components/posts/Post.tsx











var Post = function(param) {
    var layout = param.layout, post = param.post, domain = param.domain, dbName = param.dbName, postTags = param.postTags, translationsData = param.translationsData;
    var router = (0,next_router.useRouter)();
    var postClasses = classnames_default()((posts_module_default()).typography, layout === "full" && (posts_module_default())["typography--expanded"]);
    if (!post) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    var createMarkup = function(item) {
        return {
            __html: item
        };
    };
    var rightDay = {
        true: {
            true: (0,utils/* createRightDate */.UE)(post === null || post === void 0 ? void 0 : post.published_at),
            false: (0,utils/* createRightDate */.UE)(post === null || post === void 0 ? void 0 : post.published_at)
        },
        false: {
            true: (0,utils/* createRightDate */.UE)(post === null || post === void 0 ? void 0 : post.updated_at),
            false: (0,utils/* createRightDate */.UE)(post === null || post === void 0 ? void 0 : post.created_at)
        }
    };
    var blogDefaultImage = post.image ? (0,helper/* domainUrl */.HJ)("".concat(dbName, "/storage/").concat(domain, "/").concat(post.image)) : (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(defaultpic/* default.src */.Z.src));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "block ".concat((posts_module_default()).post_container),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (posts_module_default())["post-header--layout--".concat(layout)],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: (posts_module_default())["post-header__title"],
                        children: post.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (posts_module_default())["post-header__meta"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (posts_module_default())["post-header__meta-item"],
                            children: [
                                " ",
                                rightDay["".concat(!!(post === null || post === void 0 ? void 0 : post.published_at))]["".concat(!!(post === null || post === void 0 ? void 0 : post.updated_at))]
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (posts_module_default()).post__featured,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: blogDefaultImage,
                    alt: "Post Image",
                    placeholder: "blur",
                    layout: "fill",
                    priority: true,
                    blurDataURL: "/zega/blur1.webp"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (posts_module_default()).tags_container,
                children: postTags.map(function(tag) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (posts_module_default()).tag,
                        children: tag.name
                    }, tag.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: postClasses,
                dangerouslySetInnerHTML: createMarkup((0,utils/* replaceDescr */.lz)(post.description))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (posts_module_default()).share_container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (posts_module_default()).share_text,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* PostShareSvg */.zj, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: translationsData.PostShare
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (posts_module_default()).share_icons,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_SMSharedButton, {
                            url: "https://".concat(dbName).concat(router.asPath)
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var posts_Post = (Post);

// EXTERNAL MODULE: ./components/shared/PageHeader.tsx
var PageHeader = __webpack_require__(64465);
;// CONCATENATED MODULE: ./components/posts/PostInnerPage.tsx





var PostInnerPage = function(param) {
    var locale = param.locale, dbName = param.dbName, domain = param.domain, post = param.post, layout = param.layout, postSlug = param.postSlug, postCategory = param.postCategory, postTags = param.postTags, breadcrumb = param.breadcrumb, translationsData = param.translationsData;
    var content;
    var ref = (0,react.useState)(), redirect = ref[0], _ = ref[1];
    var prevPostSlugRef = (0,react.useRef)();
    var prevLocaleCodeRef = (0,react.useRef)();
    (0,react.useEffect)(function() {
        prevPostSlugRef.current = postSlug;
        prevLocaleCodeRef.current = locale;
    }, []);
    (0,react.useEffect)(function() {
        if (prevPostSlugRef.current !== postSlug || prevLocaleCodeRef.current !== locale) {
            prevPostSlugRef.current = postSlug;
            prevLocaleCodeRef.current = locale;
        }
    }, [
        postSlug,
        locale
    ]);
    if (redirect) {
    ///  return router.push("/404");
    }
    content = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "row ".concat((posts_module_default()).blog_container),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(posts_Post, {
            post: post,
            postTags: postTags,
            dbName: dbName,
            layout: layout,
            domain: domain,
            translationsData: translationsData
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "page",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                dbName: dbName,
                breadcrumb: breadcrumb
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: content
            })
        ]
    });
};
/* harmony default export */ var posts_PostInnerPage = (PostInnerPage);

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/ForCWV/Wrappers/MainLayout.tsx + 32 modules
var MainLayout = __webpack_require__(75947);
;// CONCATENATED MODULE: ./pages/posts/[categorySlug]/[postSlug].tsx









var _postSlug_Post = function(pageProps) {
    var domain = pageProps.domain, dbName = pageProps.dbName, post = pageProps.post, postTags = pageProps.postTags, breadcrumb = pageProps.breadcrumb, selectedLocale = pageProps.selectedLocale, postCategory = pageProps.postCategory, translationsData = pageProps.translationsData, siteName = pageProps.siteName, defaultLangCode = pageProps.defaultLangCode, locales = pageProps.locales;
    var _meta_title = post.meta_title, meta_title = _meta_title === void 0 ? "" : _meta_title, _meta_description = post.meta_description, meta_description = _meta_description === void 0 ? "" : _meta_description, _meta_keywords = post.meta_keywords, meta_keywords = _meta_keywords === void 0 ? "" : _meta_keywords, _meta_image = post.meta_image, meta_image = _meta_image === void 0 ? "" : _meta_image;
    var router = (0,next_router.useRouter)();
    var meta_url = (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(router.locale !== "catchAll" && router.locale !== defaultLangCode ? "/" + selectedLocale : "").concat(router.asPath));
    var m_img = (0,helper/* domainUrl */.HJ)("".concat(dbName, "/storage/").concat(domain, "/").concat(meta_image));
    (0,react.useEffect)(function() {
        window.onpopstate = function() {
            router.push(window.location.pathname);
        };
    }, [
        router.query.postSlug,
        selectedLocale,
        router.route
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                            children: meta_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "title",
                            content: meta_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "description",
                            content: meta_description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "keywords",
                            content: meta_keywords
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "generator",
                            content: "Zegashop.com"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "robots",
                            content: "index, follow"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "twitter:description",
                            content: meta_description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "twitter:title",
                            content: meta_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "twitter:image",
                            content: m_img
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:description",
                            content: meta_description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:title",
                            content: meta_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:keywords",
                            content: meta_keywords
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:url",
                            content: meta_url
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:locale",
                            content: selectedLocale
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:image",
                            content: m_img
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:site_name",
                            content: siteName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                            rel: "canonical",
                            href: meta_url
                        }),
                        (locales === null || locales === void 0 ? void 0 : locales.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                    rel: "alternate",
                                    href: (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(router.asPath)),
                                    hrefLang: "x-default"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                    rel: "alternate",
                                    href: (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(router.asPath)),
                                    hrefLang: defaultLangCode
                                }),
                                locales.map(function(intl) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                        rel: "alternate",
                                        href: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/").concat(intl.code).concat(router.asPath)),
                                        hrefLang: intl.code
                                    });
                                })
                            ]
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(posts_PostInnerPage, {
                    dbName: dbName,
                    postSlug: post.slug,
                    locale: selectedLocale,
                    post: post,
                    postCategory: postCategory,
                    postTags: postTags,
                    domain: domain,
                    breadcrumb: breadcrumb,
                    translationsData: translationsData
                })
            ]
        })
    }));
};
var __N_SSP = true;
/* harmony default export */ var _postSlug_ = (_postSlug_Post);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3061,7838,1818,3997,4531,9774,2888,179], function() { return __webpack_exec__(5784); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);